/* import __COLOCATED_TEMPLATE__ from './site-header.hbs'; */
import { needsUnicodeSafeFont } from 'client-portal/utils/needs-unicode-safe-font';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './site-header.module.scss';

export default class PaymentLinkSiteHeader extends Component {
  @service currentPractice;
  @service localeManager;

  styles = styles;

  get practiceName() {
    return this.currentPractice.get('fullName');
  }

  get needsUnicodeFallback() {
    return needsUnicodeSafeFont(this.currentPractice.get('fullName'));
  }
}
